import { getShapeTextFrame } from '@/components/app/shapes/shape-text-frame-registry'
import type { ClickableSpellWord } from '../types/clickable-spell-word'

/**
 * The misspelled word under a click on the canvas, or `null` when the click is on anything else.
 *
 * Each frame answers for its own text: the click has to fall inside the frame, and the character it
 * lands on has to be in the word. Words in hidden text are not drawn, so they are never under a click.
 */
export function findSpellWordAtPoint(
  words: readonly ClickableSpellWord[],
  clientX: number,
  clientY: number
): ClickableSpellWord | null {
  for (const word of words) {
    const frame = getShapeTextFrame(word.shapeId)

    if (!frame?.containsClientPoint(clientX, clientY)) continue
    // Hidden text has no place on the canvas to click.
    if (word.end > frame.getConsumedLength()) continue

    const index = frame.caretIndexAtClientPoint(clientX, clientY)

    if (index >= word.start && index <= word.end) return word
  }

  return null
}
